"use client";

import { c as _c } from "react/compiler-runtime";
import DesignIdeaHero from "./DesignIdeaHero";
import BestMatchesHeader from "./BestMatchesHeader";
import DesignIdeaContractorRows from "./DesignIdeaContractorRows";
import BringIdeasToLife from "../../../_component/BringIdeasToLife";
import CategoryFeedGrid from "../../_components/CategoryFeedGrid";
import { useCityPopup, CITY_SELECTION_STATUS } from "../../../../_provider/CityPopupProvider";
import { inhomzEvents } from "../../../../_lib/events";

// One fixed structure for all three city-selection states — hero, a "best
// matches"/"bring ideas to life" slot (mobile: stacked below hero; desktop:
// a sticky 428px dock), then similar ideas. Only the *content* inside that
// slot changes with status (real contractor rows / a loading skeleton for
// them / the BringIdeasToLife CTA); the slot's own size and position never
// does. An earlier version used two genuinely different desktop structures
// for "city known" vs "no city yet" (similar ideas inside vs. outside the
// two-column row, a 428px vs. 362px second column) — that caused a real
// layout shift once CITY_SELECTION_STATUS resolved client-side (can't be
// known before mount, see CityPopupProvider), on top of the content swap.
export default function DesignIdeaPageLayout(t0) {
  const $ = _c(32);
  const {
    category,
    image,
    title,
    similarItems,
    contractors: t1
  } = t0;
  let t2;
  if ($[0] !== t1) {
    t2 = t1 === undefined ? [] : t1;
    $[0] = t1;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const contractors = t2;
  const {
    citySelectionStatus
  } = useCityPopup();
  const isUnselected = citySelectionStatus === CITY_SELECTION_STATUS.UNSELECTED;
  const isCheckingCity = citySelectionStatus === CITY_SELECTION_STATUS.CHECKING;
  const hasContractors = contractors.length > 0;
  let t3;
  if ($[2] !== contractors || $[3] !== hasContractors || $[4] !== isCheckingCity || $[5] !== isUnselected) {
    t3 = isUnselected ? <div className="mt-4"><BringIdeasToLife trackingEvent={inhomzEvents.designDetail.BROWSE_EXPERTS_CLICKED} /></div> : !hasContractors ? null : <><BestMatchesHeader /><DesignIdeaContractorRows contractors={contractors} variant="scroll" isLoading={isCheckingCity} /></>;
    $[2] = contractors;
    $[3] = hasContractors;
    $[4] = isCheckingCity;
    $[5] = isUnselected;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  const matchesSlot = t3;
  let t4;
  if ($[7] !== contractors || $[8] !== hasContractors || $[9] !== isCheckingCity || $[10] !== isUnselected) {
    t4 = isUnselected ? <BringIdeasToLife variant="compact-card" trackingEvent={inhomzEvents.designDetail.BROWSE_EXPERTS_CLICKED} /> : !hasContractors ? null : <><BestMatchesHeader /><DesignIdeaContractorRows contractors={contractors} variant="list" isLoading={isCheckingCity} /></>;
    $[7] = contractors;
    $[8] = hasContractors;
    $[9] = isCheckingCity;
    $[10] = isUnselected;
    $[11] = t4;
  } else {
    t4 = $[11];
  }
  const matchesSlotDesktop = t4;
  let t5;
  if ($[12] !== category || $[13] !== image || $[14] !== title) {
    t5 = <DesignIdeaHero category={category} image={image} title={title} />;
    $[12] = category;
    $[13] = image;
    $[14] = title;
    $[15] = t5;
  } else {
    t5 = $[15];
  }
  let t6;
  if ($[16] !== matchesSlot) {
    t6 = <div className="lg:hidden">{matchesSlot}</div>;
    $[16] = matchesSlot;
    $[17] = t6;
  } else {
    t6 = $[17];
  }
  let t7;
  if ($[18] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <h2 className="m3-title-medium px-4 pt-6 text-[--textPrimaryPrimary] md:m3-title-large">Similar ideas</h2>;
    $[18] = t7;
  } else {
    t7 = $[18];
  }
  let t8;
  if ($[19] !== category || $[20] !== similarItems || $[21] !== title) {
    t8 = similarItems.length === 0 ? <p className="px-4 pt-2 m3-body-medium text-[--textSecondarySecondary]">No similar designs found yet.</p> : <div className="w-full px-4 pt-2"><CategoryFeedGrid title={title} category={category} items={similarItems} priorityCount={0} trackingEvent={inhomzEvents.designDetail.IMAGE_CLICKED} section="similar_ideas" /></div>;
    $[19] = category;
    $[20] = similarItems;
    $[21] = title;
    $[22] = t8;
  } else {
    t8 = $[22];
  }
  let t9;
  if ($[23] !== t5 || $[24] !== t6 || $[25] !== t8) {
    t9 = <div className="lg:min-w-0 lg:flex-1">{t5}{t6}{t7}{t8}</div>;
    $[23] = t5;
    $[24] = t6;
    $[25] = t8;
    $[26] = t9;
  } else {
    t9 = $[26];
  }
  let t10;
  if ($[27] !== matchesSlotDesktop) {
    t10 = matchesSlotDesktop && <aside className="hidden lg:sticky lg:top-6 lg:block lg:w-[428px] lg:shrink-0">{matchesSlotDesktop}</aside>;
    $[27] = matchesSlotDesktop;
    $[28] = t10;
  } else {
    t10 = $[28];
  }
  let t11;
  if ($[29] !== t10 || $[30] !== t9) {
    t11 = <div className="lg:flex lg:items-start lg:gap-8">{t9}{t10}</div>;
    $[29] = t10;
    $[30] = t9;
    $[31] = t11;
  } else {
    t11 = $[31];
  }
  return t11;
}